

































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IAgency, IUser, PolicyStatus } from 'admiral-core';
import { HashIcon, TrendingUpIcon } from 'vue-feather-icons';
import { PolicyApi } from '@/services/PolicyApi';
import { FormatMixin } from '@/mixins/FormatMixin';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  components: { HashIcon, TrendingUpIcon },
})
export default class StatisticCard extends mixins(FormatMixin) {
  @Prop({ required: true, type: Object })
  user!: IUser;

  @Prop({ required: true, type: String })
  status!: PolicyStatus;

  @Prop({ required: true, type: Array })
  selectedStatus!: PolicyStatus[];

  quantity = 0;
  value = 0;

  async mounted() {
    try {
      const result = await PolicyApi.getUserPolicyStatusStats({
        status: this.status,
        user: this.user,
      });
      this.quantity = result.data.quantity;
      this.value = result.data.value;
    } catch (e) {
      console.error(e);
    }
  }

  get agency(): IAgency {
    return this.$store.state.DataModule.agency;
  }

  get isOpen() {
    return this.status === PolicyStatus.OPEN;
  }

  get isSubmitted() {
    return this.status === PolicyStatus.SUBMITTED;
  }

  get isPoliced() {
    return this.status === PolicyStatus.POLICED;
  }

  get isDeclined() {
    return this.status === PolicyStatus.DECLINED;
  }

  async handleSelect() {
    let selectedStatus: PolicyStatus[] = [];
    if (!this.selectedStatus.includes(this.status)) {
      selectedStatus = [this.status];
    }

    this.$emit('select-status', selectedStatus);
  }
}
